import API from 'api/clients'
import { queryService } from 'modules/module-api'
import { all, fork } from 'redux-saga/effects'

import NotificationsSaga from '../sagas/NotificationsSaga'

export default function* notificationsSagas() {
  yield all([fork(new NotificationsSaga(API, queryService).supervise)])
}
